import React from 'react';
import { 
  ADD_FRIEND, 
  SHARE, 
  LIKE,
  COMMENT,
  PROFILE_IMAGE
} from '../../constants/ModalTypes';
import AddFriendModal from '../AddFriendModal';
import ShareModal from '../ShareModal';
import LikeModal from '../LikeModal';
import CommentModal from '../CommentModal';
import ProfileImageModal from '../ProfileImageModal';

const MODAL_COMPONENTS = {
  [ADD_FRIEND]: AddFriendModal,
  [SHARE]: ShareModal,
  [LIKE]: LikeModal,
  [COMMENT]: CommentModal,
  [PROFILE_IMAGE]: ProfileImageModal
};

const ModalRoot = ({ modalType, modalProps, showModal, hideModal }) => {
  if (!modalType) {
    return null;
  }
  const SpecificModal = MODAL_COMPONENTS[modalType]
  return <SpecificModal 
    showModal={showModal} 
    hideModal={hideModal} 
    {...modalProps}
  />
}

export default ModalRoot;



// WEBPACK FOOTER //
// ./src/components/ModalRoot/index.js